import React from 'react'
import { useParams } from 'react-router'
import RoundResultsPage from './RoundResultsPage'
import { data } from './data/fakePreviewData'

const RoundResultsPreview: React.FC<{}> = () => {
  const { layout } = useParams<{ layout: API.ReportingLayoutType }>()

  return (
    <div style={{ height: '100vh' }}>
      <RoundResultsPage
        data={data}
        roundNumber={3}
        onlyThesePages={[layout]}
        hidePagination
        hideHeader
        hideTeamPositions
        noAnimations
      />
    </div>
  )
}

export default RoundResultsPreview